export function havePassed24Hours(date: string) {
  return Math.abs(Date.parse(date) - Date.now()) / 36e5 > 24
}
